export enum SqlDialectType {
    MSSQL = "MSSQL",
    MySQL = "MySQL",
    PostgresSQL = "PostgresSQL",
    StandardSQL = "StandardSQL",
}